/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseSelect from './BaseSelect.vue';
import { isEmpty } from 'lodash';

/**
 * Advanced, customizable multiselect wrapper component.
 *
 * @category ui.components.form-elements
 * @exports CustomSelect
 * @component
 */
const __vue_script__ = {
    name: 'CustomSelect',

    components: {
        BaseSelect,
    },

    props: {
        // Have to overwrite this here because BaseControl
        // declares one.
        value: {
            type: [Object, Array, String, Number],
            default: null
        },

        optionsLabel: {
            type: String,
            default: 'label'
        },

        optionsIcon: {
            type: String,
            default: 'icon'
        },

        selectedOptionIconClass: {
            type: String,
            default: null
        },

        showSelectedCount: {
            type: Boolean,
            default: false
        },

        iconPerOption: {
            type: Boolean,
            default: false
        },

        taggable: {
            type: Boolean,
            default: false
        },

        newElementKey: {
            type: String,
            default: ''
        },

        labelAndHint: {
            type: Boolean,
            default: false
        },

        custom: {
            type: Boolean,
            default: false
        },
    },

    computed: {

        // merge attributes and props and pass the lot to BaseSelect
        attrs() {
            const attrs = Object.assign(this.$options.propsData, this.$attrs);
            return attrs;
        },
    },

    methods: {
        /**
         * Tries to grab the focus on the input element
         */
        attemptFocus() {
            const select = this.$refs.custom_select;

            if (this.focused && select && select.$refs.search) {
                select.$refs.search.focus();
            }
        },

        /**
         * this is a simplified version of https://github.com/shentao/vue-multiselect/blob/8b65e2ae03818f0ac4ab8d35183a3f051e4a44aa/src/multiselectMixin.js#L480 to allow for custom tag text
         * @param {Object} option the select line options
         */
        getOptionLabel(option) {
            if (isEmpty(option)) {
                return '';
            }
            if (option.isTag) {
                return this.$i18n.t(this.newElementKey, [option.label]);
            }
            return option.label;
        }
    }

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-select',_vm._g(_vm._b({ref:"custom_select",attrs:{"value":_vm.value},on:{"input":function (payload) { return _vm.$emit('input', payload); }},scopedSlots:_vm._u([(_vm.iconPerOption || _vm.selectedOptionIconClass || _vm.taggable || _vm.labelAndHint || _vm.custom)?{key:"option",fn:function(ref){
var option = ref.option;
return [(_vm.iconPerOption)?[(option[_vm.optionsIcon])?_c('i',{staticClass:"multiselect-left-icon",class:option[_vm.optionsIcon] ? ("ic-" + (option[_vm.optionsIcon])) : ''}):_vm._e(),_c('span',[_vm._v(_vm._s(option[_vm.optionsLabel]))])]:(_vm.selectedOptionIconClass)?[(option === _vm.value)?_c('i',{staticClass:"multiselect-left-icon selected",class:_vm.selectedOptionIconClass}):_vm._e(),_c('span',[_vm._v(_vm._s(option[_vm.optionsLabel]))])]:(_vm.taggable)?[_c('span',[_vm._v(_vm._s(_vm.getOptionLabel(option)))])]:(_vm.labelAndHint)?[_c('span',{staticClass:"label"},[_vm._v(_vm._s(option.label))]),_c('span',{staticClass:"separator"},[_vm._v("-")]),_c('span',{staticClass:"hint"},[_vm._v(_vm._s(_vm.$t(option.hint)))])]:(_vm.custom)?[_vm._t("customOption",null,{"option":option})]:_vm._e()]}}:null,(_vm.iconPerOption || _vm.selectedOptionIconClass || _vm.labelAndHint || _vm.custom)?{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [(_vm.iconPerOption)?[(option[_vm.optionsIcon])?_c('i',{staticClass:"multiselect-left-icon",class:option[_vm.optionsIcon] ? ("ic-" + (option[_vm.optionsIcon])) : ''}):_vm._e(),_c('span',[_vm._v(_vm._s(option[_vm.optionsLabel]))])]:(_vm.selectedOptionIconClass)?[_c('i',{staticClass:"multiselect-left-icon",class:_vm.selectedOptionIconClass}),_c('span',[_vm._v(_vm._s(option[_vm.optionsLabel]))])]:(_vm.labelAndHint)?[_c('span',{staticClass:"label"},[_vm._v(_vm._s(option.label))]),_c('span',{staticClass:"separator"},[_vm._v("-")]),_c('span',{staticClass:"hint"},[_vm._v(_vm._s(_vm.$t(option.hint)))])]:(_vm.custom)?[_vm._t("customSingleLabel",null,{"option":option})]:_vm._e()]}}:null,(_vm.showSelectedCount)?{key:"selection",fn:function(ref){
var values = ref.values;
var search = ref.search;
var isOpen = ref.isOpen;
return [(values.length > 1 && !isOpen)?_c('span',{staticClass:"multiselect__single"},[_vm._t("selectedCount",null,{"count":values.length})],2):_vm._e()]}}:null],null,true)},'base-select',_vm.attrs,false),_vm.$listeners))}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CustomSelect.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__